import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useGetAllCurrenciesQuery } from '$store/modules/currencies';
import { useCurrency } from '$hooks/useCurrency';

const DEFAULT_CURRENCY_CODE = 'USD';

export const useSyncCurrencyFromUrl = () => {
  const [searchParams] = useSearchParams();
  const { data: currencies } = useGetAllCurrenciesQuery();
  const { selectCurrency } = useCurrency();
  const currencyCodeParam =
    searchParams.get('currency') || DEFAULT_CURRENCY_CODE;

  useEffect(() => {
    if (!currencies?.length) return;
    const found =
      currencies.find((c) => c.Code === currencyCodeParam) ||
      currencies.find((c) => c.Code === DEFAULT_CURRENCY_CODE);
    if (found) selectCurrency(found);
  }, [currencies, currencyCodeParam, selectCurrency]);
};
